import React, { Component } from 'react';
import { navigateGroups } from '../../Common/navigation';
import { isEmpty, getGroupIconList } from '../../Common/common';
import Editbox from '../../Part_Sample/Editbox';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Icon_Carousel from '../../Part_Sample/Icon_Carousel';
import Management_Point_Selection_Cell from '../../Part_Sample/Management_Point_Selection_Cell';

export default class Group_Edit extends Component {
	constructor(props) {
		super(props);

		let group_name = '';
		let mp_list = {};
		let selected_mp_list = [];
		let selected_icon = 'Building.png';
		this.group_info = {};

		if (this.props.param.group_id != null || this.props.param.group_info != null) {
			this.group_info = this.props.param.group_info;
			group_name = this.group_info.name;
			selected_mp_list = this.props.param.group_info.mp;
			if (this.group_info.icon != null) selected_icon = this.group_info.icon;
		}

		if (!isEmpty(window.app.state.point_list)) {
			for (let id in window.app.state.point_list) {
				let point = {};
				point.id = id;
				point.is_selected = false;
				mp_list[id] = {};
				mp_list[id].is_selected = selected_mp_list.includes(id) ? true : false;
			}
		}

		let icon_list = getGroupIconList();
		for (let i in icon_list) {
			if (icon_list[i].key == selected_icon) {
				icon_list[i].is_selected = true;
				break;
			}
		}

		this.state = {
			group_name: group_name,
			mp_list: mp_list,
			icon_list: icon_list,
		}

	}

	handlePrevious = () => {
		if (this.props.param.from == 'Groups') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			navigateGroups("null");
		} else if (this.props.param.from == 'Group_Details') {
			this.props.content_handler('Group_Details', { group_info: this.props.param.original_group_info, group_id: this.props.param.group_id, from: this.props.param.group_detail_from })
		}
	}

	handleChangeGroupName = (group_name) => {
		this.setState({ group_name: group_name })
	}

	handleUpdateSelectedList = (id) => {
		let mp_list = this.state.mp_list;
		mp_list[id].is_selected = !mp_list[id].is_selected;
		this.setState({ mp_list: mp_list })
	}

	handleSelectIcon = (key) => {
		let icon_list = this.state.icon_list;
		for (let i in icon_list) {
			if (icon_list[i].key == key) {
				icon_list[i].is_selected = true;
			} else {
				icon_list[i].is_selected = false;
			}
		}

		this.setState({ icon_list: icon_list })
	}

	handleRegister = () => {
		if (this.state.group_name == '') {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		let selected_mp = [];
		for (let id in this.state.mp_list) {
			if (this.state.mp_list[id].is_selected) selected_mp.push(id);
		}

		if (selected_mp.length < 1) {
			window.app.showToast(this.props.receiver.getString('no_management_points'), 3000);
			return;
		}

		let selected_icon = '';
		for (let i in this.state.icon_list) {
			if (this.state.icon_list[i].is_selected) {
				selected_icon = this.state.icon_list[i].key;
				break;
			}
		}

		// Check if group name already exist
		// Edit Group allows rename to a duplicated name, so check if group_id != key
		for (let key in this.props.param.groups) {
			if (this.props.param.groups[key].name == this.state.group_name && this.props.param.group_id != key) {
				window.app.showToast(this.props.receiver.getString('name_already_exists'), 3000);
				return;
			}
		}

		let group_info = {}
		group_info.name = this.state.group_name;
		group_info.mp = selected_mp;
		group_info.icon = selected_icon;
		group_info.temp_targ = this.group_info.temp_targ;
		group_info.value_targ = this.group_info.value_targ;

		let param = JSON.parse(JSON.stringify(this.props.param));
		param.group_info = group_info;

		this.props.content_handler('Optional_Group_Display', param);
	}

	rcvAddGroupResponse = (response) => {
		if (!isEmpty(response) && response.result != 'NG') {
			this.handlePrevious();
		}
	}

	rcvModifyGroupResponse = (response) => {
		if (!isEmpty(response) && response.result == 'OK') {
			this.handlePrevious();
		}
	}

	render() {
		// Determine device orientation
		let is_landscape = this.props.width > this.props.height;

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: is_landscape ? 'inherit' : 'fixed',
			top: 0,
			width: '100%',
			height: is_landscape ? this.props.height - 56 : this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.group_id == null ? this.props.receiver.getString('add_group') : this.props.receiver.getString('edit_group')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ overflow: 'auto' }}>
						<div style={{ textAlign: 'center' }}>
							<Editbox id='grp_name' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('grp_name')} inputType='text' onChange={(event) => this.handleChangeGroupName(event.target.value)} value={this.state.group_name} />
						</div>
						<div style={{ marginTop: 20, marginLeft: 20 }}>
							<div className='subtitle' style={{ textAlign: 'left' }}>
								<span>{this.props.receiver.getString('sel_icon')}</span>
							</div>
							<div style={{ marginTop: 20 }}>
								<Icon_Carousel id={'group_icons'} width={this.props.width} icon_list={this.state.icon_list} handleSelectIcon={this.handleSelectIcon} />
							</div>
						</div>
						<div style={{ textAlign: 'left', marginLeft: 20 }}>
							<span className='subtitle'>{this.props.receiver.getString('sel_device')}</span>
						</div>
						<div style={{ height: is_landscape ? 'auto' : this.props.height - 370, overflow: 'auto', paddingBottom: is_landscape ? 56 : 0 }}>
							{Object.keys(window.app.state.point_list).map((point_id) => {
								let point_info = window.app.state.point_list[point_id];
								if (!isEmpty(point_info)) {
									let can_select_management_point = true;
									let accessible_points = this.props.receiver.active_controller.auth.points; //list of points user has/has no access to
									if (this.props.receiver.active_controller.user_class != 'Admin') { //Admin class has access to all MP, so do not have to check
										can_select_management_point = false;
										if (accessible_points.hasOwnProperty(point_id)) {
											if (accessible_points[point_id]) {
												can_select_management_point = true;
											}
										}
									}

									if (can_select_management_point) {
										return (
											<Management_Point_Selection_Cell
												id={point_id}
												height={this.props.height}
												width={this.props.width}
												key={point_id}
												handleSetToggle={this.handleUpdateSelectedList}
												point_info={point_info}
												is_selected={this.state.mp_list[point_id].is_selected}
											/>
										)
									} else {
										return null;
									}
								}
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}